import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Domain from '../common/domain.js'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(VueRouter)

const sname = Domain.name

console.info(123, Domain)

const routes = [
  // {
  //   path: '/',
  //   meta: { title: sname + ' - 首页', needLogin: false },
  //   name: 'Home',
  //   component: () => import('@/views/home'),
  // },
  {
    path: '/login',
    meta: { title: sname + ' - 登录', needLogin: false },
    component: (login) => require(['../views/login.vue'], login),
  },
  {
    path: '/wxback',
    meta: { title: sname, needLogin: false },
    component: (wxback) => require(['../views/wxback.vue'], wxback),
  },
  {
    path: '/courseCatalogue/:id',
    meta: { title: sname + ' - 课程播放', needLogin: true },
    name: 'courseCatalogue',
    component: (courseCatalogue) =>
      require(['../views/courseCatalogue.vue'], courseCatalogue),
  },
  {
    path: '/courseChapterLive/:course_id/:chapter_id',
    meta: { title: sname + ' - 直播上课', needLogin: true },
    name: 'courseChapterLive',
    component: (courseChapterLive) =>
      require(['../views/courseChapterLive.vue'], courseChapterLive),
  },
  {
    path: '/courseInformation',
    meta: { title: sname + ' - 课程资料', needLogin: true },
    name: 'COURSE_ATTACH',
    component: () => import('../components/course-information.vue'),
  },
  {
    path: '/agreeUser',
    meta: { title: sname + ' - 用户隐私政策', needLogin: false },
    component: (wxback) => require(['../views/agreeUser.vue'], wxback),
  },
  {
    path: '/agreePay',
    meta: { title: sname + ' - 用户服务协议', needLogin: false },
    component: (wxback) => require(['../views/agreePay.vue'], wxback),
  },
  {
    path: '/agreeRefund',
    meta: { title: sname + ' - 学员退费细则说明', needLogin: false },
    component: (wxback) => require(['../views/agreeRefund.vue'], wxback),
  },
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/views/layout.vue'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        meta: { title: sname + ' - 首页', needLogin: false },
        name: 'Home',
        component: () => import('@/views/index1'),
      },
      {
        path: '/course',
        meta: { title: sname + ' - 课程中心', needLogin: false },
        name: 'Course',
        component: () => import('@/views/course'),
        redirect: '/course/center',
        children: [
          {
            path: '/course/center',
            meta: {
              title: sname + ' - 课程中心',
              needLogin: false,
              barType: 'course',
            },
            name: 'CourseCenter',
            component: () => import('@/views/course/center.vue'),
          },
          {
            path: '/course/cate/:cate_id',
            meta: {
              title: sname + ' - 课程中心',
              needLogin: false,
              barType: 'course',
            },
            name: 'CourseCate',
            component: () => import('@/views/course/cate.vue'),
          },
          {
            path: '/course/details/:course_id',
            meta: { title: sname + ' - 课程详情', needLogin: false },
            name: 'CourseDetails',
            component: () => import('@/views/course/details.vue'),
          },
        ],
      },
      {
        path: '/about',
        meta: { title: sname + ' - 关于我们', needLogin: false },
        component: () => import('@/views/about.vue'),
      },
      {
        path: '/children',
        meta: { title: sname + ' - 少儿兴趣班', needLogin: false },
        component: () => import('@/views/children.vue'),
      },
      {
        path: '/open/detail',
        meta: { title: sname + '', needLogin: false },
        redirect: '/myCourses', // 重定向至个人中心
      },
      {
        path: '/teacher',
        meta: { title: sname + ' - 职业技能班', needLogin: false },
        component: () => import('@/components/teachers.vue'),
      },
      {
        path: '/lawsRegulations',
        meta: { title: sname + ' - 法律法规', needLogin: false },
        component: (lawsRegulations) =>
          require(['../views/lawsRegulations.vue'], lawsRegulations),
      },

      // 实现路由懒加载
      {
        path: '/orderDetails',
        meta: { title: sname + ' - 订单详情', needLogin: true },
        name: 'orderDetails',
        component: () => import('../components/orderDetails.vue'),
      },

      // 实现路由懒加载
      {
        path: '/article/details/:id',
        meta: { title: sname + ' - 文章详情', needLogin: false },
        name: 'articleDetails',
        component: () => import('../views/article/details.vue'),
      },

      {
        path: '/courseTable/:id',
        meta: { title: sname + ' - 课程目录', needLogin: false },
        name: 'COURSE_TABLE',
        component: () => import('../views/course-table.vue'),
      },
      {
        path: '/taskDetails/:id',
        meta: { title: sname + ' - 作业详情', needLogin: true },
        name: 'TASK_DETAILS',
        component: () => import('../views/MyCenter/taskDetails.vue'),
      },
      {
        path: '/myCenter',
        name: 'myCenter',
        redirect: '/myCourses',
        component: () => import('@/components/myCenter.vue'),
        children: [
          {
            path: '/myCourses',
            meta: { title: sname + ' - 我的课程', needLogin: true },
            component: () => import('@/components/mycenter/myCourses.vue'),
          },
          {
            path: '/mySchedule',
            meta: { title: sname + ' - 我的课表', needLogin: true },
            component: () => import('@/components/mycenter/mySchedule.vue'),
          },
          {
            path: '/myTask',
            meta: { title: sname + ' - 我的作业', needLogin: true },
            component: () => import('@/views/MyCenter/myTask.vue'),
          },
          {
            path: '/orderCenter',
            meta: { title: sname + ' - 订单中心', needLogin: true },
            component: () => import('@/components/mycenter/orderCenter.vue'),
          },
          {
            path: '/myService',
            meta: { title: sname + ' - 我的服务', needLogin: true },
            component: () => import('@/components/mycenter/myService.vue'),
          },
          {
            path: '/discountCoupon',
            meta: { title: sname + ' - 我的优惠券', needLogin: true },
            component: () => import('@/components/mycenter/discountCoupon.vue'),
          },
          {
            path: '/userHelpCenter',
            meta: { title: sname + ' - 用户帮助中心', needLogin: true },
            component: () => import('@/components/mycenter/helpCenter.vue'),
          },
          {
            path: '/accountSetting',
            meta: { title: sname + ' - 账户设置', needLogin: true },
            component: () => import('@/components/mycenter/accountSetting.vue'),
          },
        ],
      },
    ],
  },
]
const router = new VueRouter({
  mode: 'history',
  routes,
})

// 路由导航守卫
router.beforeEach((to, from, next) => {
  // console.log(to)
  // 手机端页面与pc端页面适配
  // const goMobile = {
  //   '/': 'https://wenqing123.com',
  //   '/children': 'https://wenqing123.com/index2'
  // }
  // if (document.documentElement.clientWidth < 768 && goMobile[to.path]) {
  //   location.href = goMobile[to.path]
  // }
  if (store.state.loginDialogVisible) {
    store.commit('loginDialogClose')
  }
  document.title = to.meta.title
  // console.log(to)
  if (to.meta.needLogin) {
    if (localStorage.getItem('user-token')) {
      document.body.scrollTop = document.documentElement.scrollTop = 0
      next()
    } else {
      document.title = '登录'
      next({
        replace: true,
        path: '/login',
        query: {
          // 将路由地址通过参数传递给登录页
          url: to.fullPath,
        },
      })
    }
  } else {
    document.body.scrollTop = document.documentElement.scrollTop = 0
    next()
  }
})

export default router
